module.exports = __webpack_public_path__ + "img/reply-all.124b9199.svg";